angular.module('aprima-core-ui')
    .directive('apAppointmentContextMenu', ['$rootScope', 'SecurityRepository', 'Permissions',
        function ($rootScope, SecurityRepository, Permissions) {
        'use strict';

        $rootScope.setOptsForApptContextMenu = function setOptsForApptContextMenu(opts) {
            $rootScope.$emit('open-appt-context-menu', opts);
        };

        return {
            restrict: 'E',
            scope: {},
            templateUrl: '/core-ui/views/directives/apAppointmentContextMenu.html',
            link: function($scope) {
                $scope.getChargeCaptureTransition = function getChargeCaptureTransition() {
                    return {
                        appRoute: 'chargeCapture',
                        opts: {
                            patientId: getPatientId(),
                            serviceSiteId: $scope.appointment.ServiceSiteId
                        }
                    };
                };
                
                var deregister = $rootScope.$on('open-appt-context-menu', function(evt, obj) {
                    $scope.appointment = obj && obj.appointment;
                    SecurityRepository.getPermissions(Permissions.Schedule)
                        .then(function(permission) {
                            $scope.schedulePermissionAllowed = permission && permission.IsAllowed;
                        })
                        .catch(function() {
                            $scope.schedulePermissionAllowed = false;
                        });
                });

                $scope.$on('$destroy', function() {
                    deregister();
                });

                function getPatientId()
                {
                    if ($scope.appointment)
                    {
                        if ($scope.appointment.PatientId)
                        {
                            return $scope.appointment.PatientId;
                        }

                        if ($scope.appointment.Patient)
                        {
                            return $scope.appointment.Patient.Id;
                        }
                    }
                }
            }
        };
    }]);
